import { render, staticRenderFns } from "./autoCateStat.vue?vue&type=template&id=f3833112&scoped=true&"
import script from "./autoCateStat.vue?vue&type=script&lang=js&"
export * from "./autoCateStat.vue?vue&type=script&lang=js&"
import style0 from "./autoCateStat.vue?vue&type=style&index=0&id=f3833112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3833112",
  null
  
)

component.options.__file = "autoCateStat.vue"
export default component.exports